(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["berrys-product-finance"] && !Shopify.designMode) return;
  try {
    (() => {
  if (customElements.get('berrys-finance-options')) return;
  class BerrysProductFinance extends HTMLElement {
    static money(value) { return new Intl.NumberFormat('en-GB', {style:'currency',currency:'GBP'}).format(value / 100); }
    static pence(value) {
      const text = String(value ?? '').replace(/,/g, '').trim();
      if (!/^\d+(\.\d{1,2})?$/.test(text)) return NaN;
      return Math.round(Number(text) * 100);
    }
    static quote(price, deposit, plan) {
      if (!Number.isSafeInteger(price) || !Number.isSafeInteger(deposit) || deposit < 0 || deposit >= price || !Number.isInteger(plan.months) || plan.months < 1) throw new Error('Invalid finance inputs');
      const credit = price - deposit;
      let monthly, final;
      if (plan.apr === 0) {
        monthly = Math.floor(credit / plan.months);
        final = credit - monthly * (plan.months - 1);
      } else {
        if (!/^0\.\d{1,12}$/.test(plan.multiplier)) throw new Error('Missing lender repayment factor');
        const decimals = plan.multiplier.split('.')[1];
        const factor = BigInt(decimals), divisor = 10n ** BigInt(decimals.length);
        monthly = Number((BigInt(credit) * factor + divisor - 1n) / divisor);
        final = monthly;
      }
      const total = deposit + monthly * (plan.months - 1) + final;
      return {...plan, price, deposit, credit, monthly, final, total, cost:total-price};
    }
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.allowedFinancePlans = new Set(JSON.parse(this.dataset.financeTags || '[]').filter(tag => /^finance_(0|9\.9)_[1-9]\d*$/.test(tag)));
      this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
      this.labels = JSON.parse(this.querySelector('[data-labels]').textContent);
      this.dialog = this.querySelector('dialog');
      this.summary = this.querySelector('[data-summary]');
      this.calculation = this.querySelector('[data-calculation]');
      this.amount = this.querySelector('[data-deposit]');
      this.term = this.querySelector('[data-term]');
      this.openButton = this.querySelector('[data-open]');
      this.purchaseButton = this.querySelector('[data-purchase]');
      this.split = this.querySelector('[data-split]');
      this.planButtons = Array.from(this.querySelectorAll('[data-plan]'));
      this.planButtons.forEach(button => button.addEventListener('click', () => this.openPlan(button.dataset.plan, button)));
      this.scope = this.closest('.shopify-section') || document;
      this.scopeChange = event => {
        if (event.target.matches('input[name="id"],select[name="id"]')) this.loadVariant(event.target.value);
      };
      this.scope.addEventListener('change', this.scopeChange);
      this.openButton.addEventListener('click', () => this.openPlan(`${this.defaultQuote.apr}:${this.defaultQuote.months}`, this.openButton));
      this.purchaseButton.addEventListener('click', () => this.addToBag());
      this.querySelector('[data-close]').addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('close', () => {
        if (this.returnFocusOnClose !== false) (this.returnFocusTarget || this.openButton).focus({preventScroll:true});
      });
      this.dialog.addEventListener('click', event => { if (event.target === this.dialog) {
        const box = this.dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.dialog.close();
      }});
      this.amount.addEventListener('input', () => this.updateCalculation());
      this.term.addEventListener('change', () => this.updateCalculation());
      this.loadVariant(this.dataset.variant);
    }
    disconnectedCallback() {
      this.request?.abort();
      this.scope?.removeEventListener('change', this.scopeChange);
      this.initialized = false;
    }
    openPlan(key, trigger) {
      const plan = this.plans?.find(item => `${item.apr}:${item.months}` === key);
      if (!plan || this.hidden) return;
      this.amount.value = (this.minimum / 100).toFixed(2);
      this.term.value = key;
      this.updateCalculation();
      this.returnFocusTarget = trigger;
      this.returnFocusOnClose = true;
      this.dialog.showModal();
    }
    renderSplit() {
      if (!this.split) return false;
      let visible = 0;
      this.planButtons.forEach(button => {
        const apr = Number(button.dataset.planApr);
        const quote = this.plans.filter(plan => plan.apr === apr)
          .map(plan => BerrysProductFinance.quote(this.price, this.minimum, plan))
          .sort((a,b) => a.monthly-b.monthly || a.total-b.total || a.months-b.months)[0];
        button.hidden = !quote;
        button.dataset.plan = quote ? `${quote.apr}:${quote.months}` : '';
        if (!quote) return;
        visible++;
        button.querySelector('[data-plan-monthly]').textContent = BerrysProductFinance.money(quote.monthly);
        button.querySelector('[data-plan-deposit]').textContent = BerrysProductFinance.money(quote.deposit);
        button.querySelector('[data-plan-term]').textContent = this.text('cardTerm', {months:quote.months});
        button.querySelector('[data-plan-percent]').textContent = this.text('cardDeposit', {percent:Number((quote.deposit*100/quote.price).toFixed(2))});
      });
      if (!visible) return false;
      this.split.hidden = false;
      this.summary.hidden = true;
      this.querySelector('.bf-actions').hidden = true;
      this.classList.add('bf-finance--split');
      return true;
    }
    text(key, values = {}) {
      return this.labels[key].replace(/\{(\w+)\}/g, (_, name) => String(values[name] ?? ''));
    }
    purchaseTarget() {
      return this.scope.querySelector('product-actions-form form[data-type="add-to-cart-form"] button[name="add"][type="submit"]');
    }
    syncPurchaseButton(validQuote = true) {
      const target = this.purchaseTarget();
      this.purchaseButton.hidden = !target;
      if (!target) return;
      const optionsRequired = target.hasAttribute('data-select-option');
      this.purchaseButton.disabled = !validQuote || (!optionsRequired && (target.disabled || target.getAttribute('aria-disabled') === 'true' || getComputedStyle(target).display === 'none'));
      this.purchaseButton.textContent = optionsRequired ? this.purchaseButton.dataset.optionsLabel : (target.querySelector('span')?.textContent.trim() || this.purchaseButton.dataset.defaultLabel);
    }
    addToBag() {
      this.updateCalculation();
      const target = this.purchaseTarget();
      if (!this.dialog.open || !target || this.purchaseButton.disabled) return;
      const form = target.form;
      if (!form) return;
      this.returnFocusOnClose = false;
      this.dialog.close();
      requestAnimationFrame(() => {
        if (target.hasAttribute('data-select-option')) {
          const options = this.scope.querySelector('variant-radios');
          const control = Array.from(options?.querySelectorAll('button,select,input:not([type="hidden"]):not([disabled]),[tabindex]') || []).find(element => element.getClientRects().length && getComputedStyle(element).visibility !== 'hidden');
          options?.scrollIntoView({block:'center',behavior:'smooth'});
          control?.focus({preventScroll:true});
          return;
        }
        if (target.disabled || target.getAttribute('aria-disabled') === 'true') return;
        if (!form.reportValidity()) return;
        target.focus({preventScroll:true});
        target.click();
        const consent = form.querySelector('#wrings-crafting-consent');
        if (consent && !consent.checked) {
          consent.scrollIntoView({block:'center'});
          consent.focus({preventScroll:true});
        }
      });
    }
    async loadVariant(id) {
      if (this.currentVariant === String(id)) return;
      this.currentVariant = String(id);
      this.request?.abort();
      this.request = null;
      if (this.dialog.open) this.dialog.close();
      this.hidden = true;
      this.classList.remove('bf-finance--personal', 'bf-finance--split');
      if (this.split) this.split.hidden = true;
      this.planButtons.forEach(button => { button.hidden = true; });
      const personal = this.querySelector('[data-personal]');
      if (personal) personal.hidden = true;
      this.querySelector('[data-fallback]').hidden = true;
      this.summary.hidden = false;
      this.querySelector('.bf-actions').hidden = false;
      const variant = this.variants.find(item => item.id === String(id));
      if (!variant?.available) return;
      if (personal && this.dataset.highJewellery === 'true' && variant.price >= 4000000) {
        this.summary.hidden = true;
        this.querySelector('.bf-actions').hidden = true;
        personal.hidden = false;
        this.classList.add('bf-finance--personal');
        this.hidden = false;
        return;
      }
      if (!this.allowedFinancePlans.size) return;
      const controller = new AbortController();
      this.request = controller;
      const timeout = setTimeout(() => controller.abort(), 12000);
      try {
        const query = new URLSearchParams({pId:this.dataset.product,vId:String(id)});
        const base = 'https://berrysjewellers.financepayment.co.uk';
        const responses = await Promise.all([
          fetch(`${base}/api/v1/finance/product-page?${query}`, {signal:controller.signal,credentials:'omit'}),
          fetch(`${base}/v1/iframe/product-page?${query}`, {signal:controller.signal,credentials:'omit'})
        ]);
        if (responses.some(response => !response.ok)) throw new Error('Finance unavailable');
        const [status, source] = await Promise.all([responses[0].json(), responses[1].text()]);
        if (controller !== this.request || !this.isConnected) return;
        if (status.status !== 'true' && status.status !== true) return;
        const documentData = new DOMParser().parseFromString(source, 'text/html');
        const input = documentData.querySelector('#depositFinAmount');
        if (!input) throw new Error('Missing finance configuration');
        const price = BerrysProductFinance.pence(input.dataset.price);
        if (price !== variant.price) throw new Error('Finance price does not match variant');
        this.price = price;
        this.minimum = Math.max(Math.ceil(price * 5 / 100), BerrysProductFinance.pence(input.dataset.min));
        this.maximum = Math.min(Math.floor(price / 2), BerrysProductFinance.pence(input.dataset.max));
        if (!Number.isSafeInteger(this.minimum) || !Number.isSafeInteger(this.maximum) || this.minimum > this.maximum) throw new Error('Invalid deposit range');
        this.plans = Array.from(documentData.querySelectorAll('#adjust_months .monthSel')).map(point => ({
          months:Number(point.getAttribute('value')),apr:Number(point.dataset.monthapr),rate:Number(point.dataset.interestrate),multiplier:point.dataset.monthmultiplier || ''
        })).filter(plan => Number.isInteger(plan.months) && plan.months > 0 && plan.months <= 120 && [0,9.9].includes(plan.apr) && plan.rate === plan.apr && (plan.apr === 0 || /^0\.\d{1,12}$/.test(plan.multiplier)));
        this.plans = this.plans.filter(plan => this.allowedFinancePlans.has(`finance_${plan.apr}_${plan.months}`));
        if (!this.plans.length) return;
        this.defaultQuote = this.plans.map(plan => BerrysProductFinance.quote(price, this.minimum, plan)).sort((a,b) => a.monthly-b.monthly || a.total-b.total || a.months-b.months)[0];
        this.term.replaceChildren(...this.plans.map(plan => new Option(this.text('termOption',{months:plan.months,apr:plan.apr}),`${plan.apr}:${plan.months}`)));
        this.amount.min = (this.minimum / 100).toFixed(2);
        this.amount.max = (this.maximum / 100).toFixed(2);
        this.querySelector('[data-deposit-help]').textContent = this.text('depositHelp',{min:BerrysProductFinance.money(this.minimum),max:BerrysProductFinance.money(this.maximum)});
        this.renderQuote(this.summary, this.defaultQuote);
        this.renderSplit();
        this.hidden = false;
      } catch (error) {
        if (controller !== this.request || !this.isConnected) return;
        this.summary.hidden = true;
        this.querySelector('.bf-actions').hidden = true;
        this.querySelector('[data-fallback]').hidden = false;
        this.hidden = false;
      } finally {clearTimeout(timeout);}
    }
    updateCalculation() {
      const deposit = BerrysProductFinance.pence(this.amount.value);
      const valid = this.amount.validity.valid && Number.isSafeInteger(deposit) && deposit >= this.minimum && deposit <= this.maximum;
      this.amount.setAttribute('aria-invalid', String(!valid));
      const error = this.querySelector('[data-error]');
      error.hidden = valid;
      this.calculation.hidden = !valid;
      this.syncPurchaseButton(valid);
      if (!valid) {
        error.textContent = this.text('depositError',{min:BerrysProductFinance.money(this.minimum),max:BerrysProductFinance.money(this.maximum)});
        return;
      }
      const plan = this.plans.find(item => `${item.apr}:${item.months}` === this.term.value);
      this.renderQuote(this.calculation, BerrysProductFinance.quote(this.price, deposit, plan));
    }
    renderQuote(target, quote) {
      const money = BerrysProductFinance.money;
      const values = {price:money(quote.price),deposit:money(quote.deposit),credit:money(quote.credit),months:quote.months,monthly:money(quote.monthly),total:money(quote.total),cost:money(quote.cost),rate:quote.rate,apr:quote.apr,final:money(quote.final),regularMonths:quote.months-1};
      const percent = Number((quote.deposit * 100 / quote.price).toFixed(2));
      const example = [this.text('cashDeposit',values),this.text('credit',values),this.text(quote.final === quote.monthly ? 'payments' : 'paymentsFinal',values),this.text('total',values),this.text('cost',values),this.text('interest',values),this.text('apr',values)].join(' ');
      const fragment = this.querySelector('[data-quote-template]').content.cloneNode(true);
      const fields = {monthly:money(quote.monthly),apr:`${quote.apr}%`,basis:this.text('basis',{...values,percent}),example};
      for (const [key,value] of Object.entries(fields)) fragment.querySelector(`[data-field="${key}"]`).textContent = value;
      if (target === this.summary) fragment.querySelector('.bf-example').remove();
      target.replaceChildren(fragment);
    }
  }
  customElements.define('berrys-finance-options', BerrysProductFinance);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["berrys-purchase-reassurance"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function(event) {
  const link = event.target.closest('a[data-berrys-delivery]');
  if (!link) return;
  const panel = document.getElementById(link.dataset.berrysDelivery);
  if (!panel) return;
  event.preventDefault();
  panel.open = true;
  panel.scrollIntoView({block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
  panel.querySelector('summary')?.focus({preventScroll: true});
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["berrys-ring-size-guide"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('berrys-ring-guide')) {
    customElements.define('berrys-ring-guide', class extends HTMLElement {
      connectedCallback() {
        this.drawer = this.closest('.bj-drawer--ring');
        if (!this.drawer) return;
        this.wasOpen = false;
        this.onKeydown = event => {
          if (!this.drawer.classList.contains('active')) return;
          if (event.key === 'Escape') {
            event.preventDefault();
            event.stopPropagation();
            this.drawer.classList.remove('active');
          }
          if (event.key === 'Tab') {
            const items = Array.from(this.drawer.querySelectorAll('button, a[href], summary, [tabindex="0"]')).filter(item => !item.disabled && item.getClientRects().length);
            const first = items[0];
            const last = items[items.length - 1];
            if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
            else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
          }
        };
        this.syncOpenState = () => {
          const open = this.drawer.classList.contains('active');
          this.drawer.inert = !open;
          this.drawer.setAttribute('aria-hidden', String(!open));
          if (open && !this.wasOpen) {
            this.opener = document.activeElement;
            this.drawer.querySelector('.bj-drawer-body').scrollTop = 0;
            this.drawer.querySelector('.bj-drawer-btn-close').focus({ preventScroll: true });
          } else if (!open && this.wasOpen && this.opener?.isConnected) {
            this.opener.focus({ preventScroll: true });
          }
          this.wasOpen = open;
        };
        this.observer = new MutationObserver(this.syncOpenState);
        this.observer.observe(this.drawer, { attributes: true, attributeFilter: ['class'] });
        this.drawer.addEventListener('keydown', this.onKeydown);
        this.syncOpenState();
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.drawer?.removeEventListener('keydown', this.onKeydown);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["berrys-stock-delivery"] && !Shopify.designMode) return;
  try {
    function deliveryState(now, config) {
  const parts = Object.fromEntries(new Intl.DateTimeFormat('en-GB', {timeZone:'Europe/London',year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',second:'2-digit',hourCycle:'h23'}).formatToParts(now).map(p=>[p.type,p.value]));
  const today = `${parts.year}-${parts.month}-${parts.day}`;
  const validDate = s => /^\d{4}-\d{2}-\d{2}$/.test(s) && !Number.isNaN(Date.parse(s)) && new Date(s+'T12:00:00Z').toISOString().slice(0,10)===s;
  const list = s => String(s || '').split(/[\s,]+/).filter(Boolean);
  const dates = s => { const a=list(s); if(a.some(d=>!validDate(d))) throw Error('Invalid closure date'); return new Set(a); };
  const next = d => new Date(Date.parse(d+'T12:00:00Z')+86400000).toISOString().slice(0,10);
  const weekday = d => new Date(d+'T12:00:00Z').getUTCDay() || 7;
  const format = d => new Intl.DateTimeFormat('en-GB',{timeZone:'UTC',weekday:'long',day:'numeric',month:'long'}).format(new Date(d+'T12:00:00Z'));
  const fallback = {mode:'stock',text:''};
  try {
    if(config.override) {
      const start=String(config.start||'').trim(), end=String(config.end||'').trim();
      if((start&&!validDate(start))||(end&&!validDate(end))||(start&&end&&start>end)) return {...fallback,error:true};
      if((!start||today>=start)&&(!end||today<=end)) return {mode:'manual',text:config.manual||''};
    }
    if(!config.estimate) return fallback;
    const dispatchClosed=dates(config.dispatchClosed), deliveryClosed=dates(config.deliveryClosed);
    const days=list(config.days).map(Number);
    if(!days.length||days.some(d=>!Number.isInteger(d)||d<1||d>7)) return {...fallback,error:true};
    const hour=Number(config.hour), minute=Number(config.minute);
    if(!Number.isInteger(hour)||hour<0||hour>23||!Number.isInteger(minute)||minute<0||minute>59) return {...fallback,error:true};
    const seconds=Number(parts.hour)*3600+Number(parts.minute)*60+Number(parts.second);
    const cutoff=hour*3600+minute*60;
    let dispatch=today;
    if(seconds>=cutoff) dispatch=next(dispatch);
    let found=false;
    for(let i=0;i<370;i++,dispatch=next(dispatch)) if(days.includes(weekday(dispatch))&&!dispatchClosed.has(dispatch)){found=true;break;}
    if(!found) return {...fallback,error:true};
    let delivery=next(dispatch); found=false;
    for(let i=0;i<370;i++,delivery=next(delivery)) if(weekday(delivery)!==7&&(config.saturday||weekday(delivery)!==6)&&!deliveryClosed.has(delivery)){found=true;break;}
    if(!found) return {...fallback,error:true};
    const remaining=Math.ceil((cutoff-seconds)/60);
    const hours=Math.floor(remaining/60), minutes=remaining%60;
    const countdown=[hours>0?`${hours} ${hours===1?'hour':'hours'}`:'',minutes>0?`${minutes} ${minutes===1?'minute':'minutes'}`:''].filter(Boolean).join(' ');
    const sameDay=dispatch===today;
    const deliveryLabel=delivery===next(today)?(weekday(delivery)===6?'Saturday':'tomorrow'):format(delivery);
    const dispatchLabel=new Intl.DateTimeFormat('en-GB',{timeZone:'UTC',weekday:'long'}).format(new Date(dispatch+'T12:00:00Z'));
    const text=String(sameDay?config.before:config.after).replaceAll('{countdown}',countdown).replaceAll('{dispatch}',dispatchLabel).replaceAll('{delivery}',deliveryLabel);
    return {mode:sameDay?'countdown':'scheduled',dispatch,delivery,countdown:sameDay?countdown:null,text};
  } catch { return {...fallback,error:true}; }
}

if(!customElements.get('berrys-stock-delivery')) {
  customElements.define('berrys-stock-delivery',class extends HTMLElement {
    connectedCallback() {
      try {
        this.config=JSON.parse(this.dataset.config);
        this.variants=JSON.parse(this.dataset.variants);
      } catch { this.hidden=true; return; }
      this.form=document.getElementById(this.dataset.form);
      this.selected=this.dataset.selected;
      this.pending=this.dataset.requireSelection==='true';
      this.onVariant=e=>{
        if(e.target!==this.form && !this.form?.contains(e.target)) return;
        this.selected=e.detail?.variant?.id?String(e.detail.variant.id):null;
        this.pending=false;
        this.unavailable=e.detail?.variant?.available===false;
        this.render();
      };
      this.onChange=e=>{
        if(!this.form?.contains(e.target) && e.target.form!==this.form) return;
        if(e.target.name==='id') {this.selected=String(e.target.value);this.pending=false;this.unavailable=false;}
        else if(e.target.name?.startsWith('option')) {this.pending=true;this.hidden=true;}
        this.render();
      };
      document.addEventListener('variant:change',this.onVariant);
      document.addEventListener('change',this.onChange);
      this.timer=setInterval(()=>{
        const id=this.form?.querySelector('[name="id"]')?.value;
        if(id && id!==this.selected){this.selected=id;this.pending=false;this.unavailable=false;}
        this.render();
      },1000);
      this.render();
    }
    disconnectedCallback(){clearInterval(this.timer);document.removeEventListener('variant:change',this.onVariant);document.removeEventListener('change',this.onChange);}
    render(){
      const ready=this.variants.some(v=>v.id===String(this.selected)&&v.ready);
      const button=this.form?.querySelector('[name="add"]');
      this.hidden=!ready||this.pending||this.unavailable||Boolean(button?.disabled);
      if(this.hidden)return;
      let text='';
      if(this.dataset.productNote) text=this.dataset.productNote;
      else if(this.dataset.uk==='true'&&this.dataset.excludeDelivery!=='true') text=deliveryState(new Date(),this.config).text;
      const copy=this.querySelector('[data-delivery-copy]');
      const next=text||'';
      if(copy.textContent!==next)copy.textContent=next;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["component-pdp-actions"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    const checkbox = document.getElementById('wrings-crafting-consent');
    if (!checkbox) return;

    const form = checkbox.closest('form');
    if (!form) return;

    const addToCartBtn = form.querySelector('[type="submit"], .product-form__submit, button[name="add"]');
    if (!addToCartBtn) return;

    const messageWrapper = document.getElementById('wrings-crafting-message');
    const craftingMessage = messageWrapper?.dataset?.craftingMessage || '';

    addToCartBtn.addEventListener('click', function (e) {
      if (!checkbox.checked) {
        e.preventDefault();
        e.stopImmediatePropagation();

        if (!document.getElementById('crafting-consent-error')) {
          const error = document.createElement('div');
          error.id = 'crafting-consent-error';
          error.style.color = 'red';
          error.style.marginTop = '8px';
          error.textContent = 'Please agree to the crafting time consent before adding to cart.';
          const messageWrapper = document.getElementById('wrings-crafting-message');
          if (messageWrapper) messageWrapper.appendChild(error);
        }

        return false;
      }

      // Checkbox is checked, remove any existing error
      const existingError = document.getElementById('crafting-consent-error');
      if (existingError) existingError.remove();

      // Add hidden input if not already added
      if (!form.querySelector('[name="properties[Crafting Message]"]')) {
        const hiddenInput = document.createElement('input');
        hiddenInput.type = 'hidden';
        hiddenInput.name = 'properties[Crafting Message]';
        hiddenInput.value = craftingMessage;
        form.appendChild(hiddenInput);
      }
    });

    checkbox.addEventListener('change', function () {
      if (this.checked) {
        const existingError = document.getElementById('crafting-consent-error');
        if (existingError) existingError.remove();
      }
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["fope-size-guide-drawer"] && !Shopify.designMode) return;
  try {
    (() => {
    const initialiseGuide = (root) => {
      if (root.dataset.fopeGuideReady === 'true') return;

      root.dataset.fopeGuideReady = 'true';
      const tabs = Array.from(root.querySelectorAll('[data-fope-tab]'));
      const panels = Array.from(root.querySelectorAll('[data-fope-panel]'));

      const activate = (name, moveFocus = false) => {
        tabs.forEach((tab) => {
          const isActive = tab.dataset.fopeTab === name;
          tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
          tab.tabIndex = isActive ? 0 : -1;
          if (isActive && moveFocus) tab.focus();
        });

        panels.forEach((panel) => {
          panel.hidden = panel.dataset.fopePanel !== name;
        });
      };

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activate(tab.dataset.fopeTab));
        tab.addEventListener('keydown', (event) => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();

          let nextIndex = index;
          if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = tabs.length - 1;
          activate(tabs[nextIndex].dataset.fopeTab, true);
        });
      });

      activate(root.dataset.defaultPanel || 'bracelets');
    };

    document.querySelectorAll('[data-fope-guide]').forEach(initialiseGuide);
  })();
  } catch(e) { console.error(e); }
})();

})();
